import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {interval, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {map, mergeMap} from 'rxjs/operators';
import {User} from '../models/user';
import {Router} from '@angular/router';
import {CommonService} from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isPinging: boolean;

  constructor(@Inject(DOCUMENT) private document: Document,
              private http: HttpClient,
              private router: Router,
              private commonService: CommonService) {
  }

  public login(): void {
    if (environment.production) {
      document.location.href = 'https://res.tuke.sk/oauth2/authorization/kpi-fei';
    } 
    else if (environment.development) {
      this.document.location.href = '/oauth2/authorization/kpi-fei';
    } else {
      document.location.href = 'http://localhost/oauth2/authorization/kpi-fei';
      // this.createDevUser();
    }
  }

  public logout(): void {
    localStorage.removeItem('uuid');
    localStorage.removeItem('user');
    if (environment.production) {
      document.location.href = 'https://res.tuke.sk/logout';
    } 
    else if (environment.development) {
      this.document.location.href = '/logout';
    } else {
      document.location.href = 'http://localhost/logout';
    }
  }

  public authenticateUser(): Observable<any> {
    if (environment.production || environment.development) {
      return this.http.get(`${environment.api_url}/user`)
        .pipe(
          map((user: User) => {
            if (user.login) {
              localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
          })
        );
    } else {
      return this.http.get(`${environment.api_url}/user`, {
        withCredentials: true
      })
        .pipe(
          map((res: any) => {
            return res;
          })
        );
    }
  }

  public isAuthenticated(): Promise<boolean> {
    return this.authenticateUser().toPromise().then(usr => {
      if (!usr.login) {
        localStorage.removeItem('uuid');
        localStorage.removeItem('user');
        this.commonService.userFullName.next(null);
        this.login();
      } else {
        localStorage.setItem('uuid', JSON.stringify(usr.idUser));
        localStorage.setItem('user', JSON.stringify(usr));
        this.commonService.userFullName.next(usr.fullName);
        this.ping();
      }
      return usr.login !== null;
    });
  }

  public ping(): void {
    if (!this.isPinging) {
      this.isPinging = true;
      interval(5 * 60 * 1000)
        .pipe(
          mergeMap(() => this.isAuthenticated())
        )
        .subscribe();
    }
  }

  private createDevUser(): void {
    const devUser: User = {
      idUser: 2628,
      login: 'jp468vf',
      fullName: 'prof. Ing. Jaroslav Porubän, PhD.',
      email: 'jaroslav.poruban@tuke.sk',
      uidnumber: 2628,
      employee: {
        idEmployee: 2628,
        firstName: 'Jaroslav',
        lastName: 'Porubän',
        titleBefore: 'prof. Ing.',
        titleAfter: 'PhD.',
        email: 'jaroslav.poruban@tuke.sk',
        phone: '+421 55 6022577',
        web: null,
        login: 'jp468vf',
        employmentType: 'P',
        idDepartment: 104009,
        fullName: 'prof. Ing. Jaroslav Porubän, PhD.'
      },
      department: {
        idDepartment: 104009,
        acronym: 'KPI',
        name: 'Katedra počítačov a informatiky',
        nameEn: 'Department of Computers and Informatics',
        color: '#EAAA00',
        web: 'http://kpi.fei.tuke.sk'
      },
      faculty: {
        idDepartment: 1040,
        acronym: 'FEI',
        name: 'Fakulta elektrotechniky a informatiky',
        nameEn: 'Faculty of Electrical Engineering and Informatics',
        color: '#EAAA00',
        web: 'http://fei.tuke.sk'
      },
      roles: [
        {
          idRole: 1,
          name: 'university_admin'
        }
      ]
    };
    localStorage.setItem('uuid', JSON.stringify(devUser.employee.idEmployee));
    localStorage.setItem('user', JSON.stringify(devUser));
    this.commonService.userFullName.next(devUser.fullName);
  }
}
